import React from 'react'
import { Link } from "react-router-dom";
// import StyledButton from '../../components/layout_components/StyledButton'
import { footerAssets, generalAssets } from '../../assets/media'

import { SiYoutube } from "react-icons/si"
import { GrFacebookOption, GrLinkedinOption, GrTwitter } from "react-icons/gr"


const { footerBrands, iso, eugdpr } = footerAssets
const { logoYellow } = generalAssets.brandLogo



export const Footer = () => {

    const date = new Date()
    const year = date.getFullYear()
    const footerNavItems = [
        [
            {
                name: "Home Page",
                url: "/"
            },
            {
                name: "About Us",
                url: "/about"
            },
            {
                name: "Pricing",
                url: "/plans"
            },
        ],
        [
            {
                name: "Contact Us",
                url: "/contact"
            },
            {
                name: "Test Library",
                url: "/test-library"
            },
        ],
        [
            {
                name: "Privacy Policy",
                url: "https://thetalentgames.com/privacy-policy/"
            },
            {
                name: "Terms of use",
                url: "https://thetalentgames.com/terms-of-use/"
            },
        ],

    ]


    const footerContent = {
        footerHeroText: "We are world's leading gamified assessment solutions company. Using our hiring games, companies and their recruiting teams assess, engage and hire top talent virtually."
    }


    return (
        <footer>

            <div className="footerWrapper my-2 items-center  lg:flex lg:justify-between lg:items-center sm:w-[40rem] lg:w-[90vw] mx-auto text-sm">
                <div className="col3 p-5 lg:p-0 md:hidden">
                    <img className='h-[20rem] object-contain lg:h-[22rem] lg:w-[35rem] xl:h-[24rem] xl:w-[30rem] md:w-[40rem] sm:w-[40rem] w-[40rem]' src={footerBrands} alt="" />
                </div>
                <div className="col1 xl:w-[28rem] lg:w-[26rem] p-5">
                    <div className="brandLogo my-1 flex justify-center lg:justify-start">
                        <img src={logoYellow} className="w-[20rem] object-contain" alt="logo" />
                    </div>

                    <div className="colDesc my-5">
                        <p className='text-[16px] leading-[30px] text-center lg:text-left 2xl:text-[14px] 2xl:leading-[21px] lg:font-[400] text-[#333333]'>{footerContent.footerHeroText}</p>
                    </div>

                    {/* <div className="subcription my-5 border-2 border-[#9E9E9E] rounded-3xl flex relative h-[2.6rem]">
                        <div className="input">

                            <input className='rounded-3xl ml-6 w-[17rem] h-full border-none focus:outline-none' placeholder='Enter your email' type="text" />
                        </div>
                        <div className="subbtn">

                            <StyledButton btnText={"SUBSCRIBE NOW"} customStyle={`!bg-[#FFD700] text-[#333333] absolute right-1 top-[3.5px] !h-[1.9rem] !w-[8rem] !text-black !text-[10px] font-[400] lg:!w-[120px]`} />
                        </div>


                    </div> */}
                    <div className="socials flex justify-center lg:justify-start ml-1">
                        <a href="https://www.youtube.com/channel/UCTjzlMHDYCqi2XubmFvb0Jw" target="_blank" rel="noreferrer">
                            <SiYoutube className='text-[1.5rem] 2xl:text-[1.7rem] text-[red] mr-2' />
                        </a>
                        <a href="https://www.facebook.com/games.talent/" target="_blank" rel="noreferrer">
                            <GrFacebookOption className='text-[1.3rem] 2xl:text-[1.5rem] text-blue-600 mr-2' />
                        </a>
                        <a href="https://twitter.com/GamesTalent" target="_blank" rel="noreferrer">
                            <GrTwitter className='text-[1.3rem] 2xl:text-[1.5rem] text-[#17A3F8] mr-2' />
                        </a>
                        <a href="https://linkedin.com/company/thetalentgames" target="_blank" rel="noreferrer">
                            <GrLinkedinOption className='text-[1.3rem] 2xl:text-[1.5rem] text-blue-600 mr-3' />
                        </a>

                    </div>
                </div>
                <div className="col2 flex justify-between lg:justify-around w-[95%] sm:w-[30rem] mx-auto lg:w-[30rem] p-5 text-[16px] lg:p-1 lg:mx-4 2xl:mx-8">
                    {
                        footerNavItems.map((footerNavItem, index) => (
                            <div key={`divFooterNav${index}`} className="subCol">
                                <ul>
                                    {
                                        footerNavItem.map((item, index) => (


                                            ["Privacy Policy", "Terms of use"].includes(item.name) ?

                                                <a href={item.url} key={`Li${item.name}${index}`}>
                                                    <li key={`li${item.name}${index}`} className='text-[16px] leading-[30px] sm:p-1 2xl:text-[18px] 2xl:leading-[44px] my-2 lg:text-[12px] xl:text-[18px] text-[#00203F] lg:font-[400] lg:leading-[22px]'>{item.name}</li>
                                                </a>

                                                :

                                                <Link key={`Li${item.name}${index}`} to={item.url} >
                                                    <li key={`li${item.name}${index}`} className='text-[16px] leading-[30px] sm:p-1 2xl:text-[18px] 2xl:leading-[44px] my-2 lg:text-[12px] xl:text-[18px] text-[#00203F] lg:font-[400] lg:leading-[22px]'>{item.name}</li>
                                                </Link>


                                        )
                                        )
                                    }
                                </ul>
                            </div>
                        ))
                    }

                </div>
                {/* <div className="col sm:w-[30rem] sm:mx-auto lg:w-[28rem] flex justify-center"> */}
                <div className="col3 p-5 lg:p-0 hidden md:block">
                    <img className='h-[20rem] object-contain lg:h-[22rem] lg:w-[35rem] xl:h-[24rem] xl:w-[30rem] md:w-[40rem] sm:w-[40rem] w-[40rem]' src={footerBrands} alt="" />
                </div>

                {/* <img className='h-[18rem] object-contain 2xl:h-[400px]' src={footerBrands} alt="" /> */}
                {/* </div> */}
            </div>

            <div className="line border-t-2 py-5 border-[#F7F7F7] text-sm text-[#9E9E9E] w-full sm:w-[40rem] lg:w-[90vw] mx-auto flex justify-around sm:justify-between items-center">
                <div className="copyright">

                    <p className='text-[10px] sm:text-xs lg:text-md 2xl:text-[14px] 2xl:leading-[18px]'>{`© ${year} The Talent Games. All rights reserved.`}</p>
                </div>
                <div className="certifications flex">

                    <img src={eugdpr} className="object-contain h-[1.5rem] lg:h-[2rem] ml-5 2xl:h-[2.5rem]" alt="" />
                    <img src={iso} className="object-contain h-[1.5rem] lg:h-[2rem] ml-5 2xl:h-[2.5rem]" alt="" />
                </div>
            </div>


        </footer>
    )
}
